<template>
    <button type="button" class="btn btn-lg btn-cart btn-bi"
            @click.prevent="this.inCart ? deleteFromCart(id) : addToCart(id)"
            v-bind:class="{'btn-outline-cart': this.inCart}"
    >
        <i class="bi bi-basket2"></i>
        <ins v-if="!this.inCart">Добавить в корзину</ins>
        <ins v-else>В корзине</ins>
    </button>
</template>

<script>
export default {
    props: ["id"],

    computed: {
        inCart() {
            if (this.$store.state.cart.items) {
                return this.$store.state.cart.items.find(
                    (x) => x.product.id == this.id
                );
            }

            return false;
        },
    },

    methods: {
        addToCart() {
            let params = {
                id: this.id
            };

            this.$store.dispatch("cart/addToCart", params);
        },

        deleteFromCart() {
            this.$store.dispatch("cart/deleteFromCart", this.id);
        },

        goToCart() {
            location.href = '/cart';
        },
    },
};
</script>
